import React, { useEffect, useState }  from 'react';
import PopUp from '../../components/PopUp';
import { TextInput, MultiSelect, Select, Divider, NumberInput, Button, Grid} from '@mantine/core';
import styles from './recipeDetails.module.css'
import { RecipeDetailsPopUpProps, Composition } from '../../types/recipes';
import {ReactComponent as  RemoveIcon } from '../../assets/icons/Remove.svg'
import api from '../../api/axiosClient';


const MIX_TEXTILE_TYPE_ID = 11;
const OTHERS_RECYCLING_CATEGORY_ID = '58';
const defaultMixMaterials: Composition[] = [{ textile_type_id: MIX_TEXTILE_TYPE_ID, percentage: 100 }];
const RecipeDetailsPopUp = ({opened, close, title, onSave, hopper, colorOpt, recyclingOpt, reuseOpt, textileOpt,colorLabelOpt}:RecipeDetailsPopUpProps)=>{

    const [productColor, setProductColor]= useState<string|null>(hopper?.product_color != null ? String(hopper.product_color) : null);
    const [productMaterials, setProductMaterials] = useState<Composition[]>(hopper?.product_materials || []);
    const [color, setColor] = useState<string[]>(hopper?.colors|| []);
    const [recycling, setRecycling] = useState<string[]>(hopper?.recycling_categories || []);
    const [reuse, setReuse] = useState<string[]>( hopper?.reuse_categories|| []);

    const handleMaterialChange = (index: number, field: keyof Composition, value: number) => {
        setProductMaterials(prev => prev.map((m, i) => i === index ? { ...m, [field]: value } : m));
    };

    const handleAddMaterial = () => {
        setProductMaterials(prev => [...prev, { textile_type_id: 0, percentage: 0 }]);
    };

    const handleRemoveMaterial = (index: number) => {
        setProductMaterials(prev => prev.filter((_, i) => i !== index));
    };

    const handleRecyclingChange = async (newRecycling: string[]) => {
        setRecycling(newRecycling);
        if (newRecycling.includes(OTHERS_RECYCLING_CATEGORY_ID)) {
            setProductMaterials(defaultMixMaterials);
            return;
        }
        if (newRecycling.length > 0) {
            try {
                const response = await api.get('/categories/conv-values', {
                    params: {
                        categoryIds: newRecycling.join(','),
                        excludeTextilTypeIds: '1,11',
                        mixId: 11
                    },
                });
                setProductMaterials(response.data);
            } catch (error) {
                console.error('Error fetching conv-values:', error);
            }
        } else {
            setProductMaterials(defaultMixMaterials);
        }
    };

    useEffect(() => {
        if (hopper) {
        setColor(hopper.colors && hopper.colors.length > 0 ? hopper.colors : []);
        setProductColor(hopper.product_color != null ? String(hopper.product_color) : null);
        const hopperHasOthers = hopper.recycling_categories?.includes(OTHERS_RECYCLING_CATEGORY_ID);
        setProductMaterials(
            hopperHasOthers
                ? defaultMixMaterials
                : (hopper.product_materials && hopper.product_materials.length > 0
                    ? hopper.product_materials
                    : (hopper.recycling_categories && hopper.recycling_categories.length > 0 ? [] : defaultMixMaterials))
        );
        setRecycling(hopper.recycling_categories || []);
        setReuse(hopper.reuse_categories|| []);
        }
    }, [hopper]);


    return(
    <PopUp  opened={opened} close={close} title={title}  onSave ={()=>{onSave(hopper?.id, hopper?.position, color, productColor, productMaterials, recycling, reuse); close();}}>
        <div >
            <TextInput label="Hopper" value={hopper?.position} disabled={true}></TextInput>  
        </div>

        <MultiSelect
            label="Colors"
            placeholder="Pick value"
            data={colorOpt}
            searchable
            maxValues={2}
            value={color} onChange={setColor}
            defaultValue={color}
        />
        <MultiSelect
            label="Recycling"
            placeholder="Pick value"
            data={recyclingOpt}
            searchable
            maxValues={4}
            value={recycling} onChange={handleRecyclingChange}
            defaultValue={recycling}
        />
        <MultiSelect
            label="Reuse"
            placeholder="Pick value"
            data={reuseOpt}
            searchable
            maxValues={4}
            value={reuse} onChange={setReuse}
            defaultValue={reuse}
        />

         <Divider my="sm" label="Product Created" labelPosition="center" color="black" styles={{ label: { color: 'black' } }} />

         <Select
            label="Color"
            placeholder="Pick value"
            data={colorLabelOpt}
            searchable
            value={productColor} 
            onChange={setProductColor}
            defaultValue={productColor}
        />

        <Grid>
            {productMaterials.map((material, index) => (
                <div key={index} style={{ display: 'flex', width: '100%' }}>
                    <Grid.Col span={5}>
                        <Select
                            label="Textile"
                            placeholder="Pick value"
                            data={textileOpt || []}
                            searchable
                            value={material.textile_type_id ? String(material.textile_type_id) : null}
                            onChange={(val) => handleMaterialChange(index, 'textile_type_id', Number(val))}
                        />
                    </Grid.Col>
                    <Grid.Col span={5}>
                        <NumberInput
                            label="%"
                            value={material.percentage}
                            onChange={(val) => handleMaterialChange(index, 'percentage', Number(val))}
                            min={0}
                            max={100}
                        />
                    </Grid.Col>
                    <Grid.Col span={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <Button variant="subtle" color="red" onClick={() => handleRemoveMaterial(index)}>
                            <RemoveIcon></RemoveIcon>
                        </Button>
                    </Grid.Col>
                </div>
            ))}
        </Grid>
        <Button variant="subtle" color="#474973" size="sm" onClick={handleAddMaterial}>+ Material</Button>        
    </PopUp>

    )
}

export default RecipeDetailsPopUp